import { message } from 'antd'
import { CLSTesting } from 'util/setLocalStorageTesting'

export const enterRandomTesting = ({
  isRandom,
  gradeId,
  subjectId,
  lessonId,
  examTypeId,
  amoungQuestions,
  history,
  publisherId
}, data) => {
  CLSTesting()
  try {
    let setState = { isRandom, gradeId, subjectId, lessonId, examTypeId, publisherId, amoungQuestions, typeExam : 'randomExam' }
    return history?.push({ pathname: '/testing', state: setState })
  } catch (error) {
    message.error('เกิดข้อผิดพลาดก่อนเข้าทำข้อสอบ', [3])
    return history.goBack()
  }
}